import { defer, LoaderFunctionArgs } from 'react-router-dom';

import { QueryClient } from '@tanstack/react-query';

import { isDefined, isNotDefined, isTokenExpired, retrieveToken } from '@hsp/utilities';

import { loaderDefaults } from '@p/a/bluebook/utilities/loader-dates/loader-defaults.util';
import { createReturnReportQuery } from '@p/a/client-report/hooks/queries/fetch-client-returns-hook';

export const returnReportLoader = (queryClient: QueryClient) => {
  return async ({ params: { clientAcronym, endDate, startDate, status } }: LoaderFunctionArgs) => {
    if (isNotDefined(clientAcronym)) {
      throw new Error('Client Acronym Parameter is required');
    }

    ({ endDate, startDate, status } = loaderDefaults(startDate, endDate, status));

    const query = createReturnReportQuery({ clientAcronym, endDate, startDate, status });
    const { queryKey } = query;

    if (!isDefined(queryKey)) {
      throw new Error('QueryKey not provided');
    }

    const token = retrieveToken();

    if (isNotDefined(token) || isTokenExpired(token)) {
      return defer({ bluebookReports: undefined });
    }

    const bluebookReport = queryClient.ensureQueryData(query);

    return defer({ bluebookReport });
  };
};
